const HousingData = [
    {
        id : "1",
        schemeName: "PM Svanidhi (Pradhan Mantri Street Vendor’s Atmanir Nidhi Scheme)",
        discription:"The PM Street Vendor’s AtmaNirbhar Nidhi (PM Svanidhi) was launched by the Ministry of Housing and Urban Affairs on June 01, 2020 for providing affordable Working Capital loan to street vendors to resume their livelihoods that have been adversely affected due to Covid-19 lockdown.",
        launchDate: "01 June 2020",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Pradhan Mantri Awas Yojna (Housing for All-Urban)",
    discription:"The Mission addresses urban housing shortage among the EWS/LIG and MIG categories including the slum Dwellers by ensuring a pucca house to all eligible urban households by the year 2022, when Nation completes 75 years of its Independence.",
    launchDate: "25 June 2015",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "Deendayal Antyoday Yojana (National Urban livelihoods Missions)",
    discription:"Economic development and urbanisation are closely linked.Cities in India are emerging as the country’s engines of economic growth, with a contribution of more than 60 per cent to GDP..",
    launchDate: "Year 2011",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "Smart Cities Mission (SCM)",
        discription:"‘Smart city’ is a city equipped with basic infrastructure to give a decent quality of life, a clean and sustainable environment through application of some smart solutions.",
        launchDate: "25 June 2015",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "Heritage City Development and Augmentation Yojana",
    discription:"It aims to preserve and rejuvenate the rich cultural heritage of the country.",
    launchDate: "January 2015", 
     AnualFund: "12345"},
   

 


]
export default HousingData;
